import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { addNursingAssessmentApi } from "../../../services/nursing.service";

const NursingAssessmentModal = ({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) => {
  const initialState = {
    patientId: "",
    visit: "",
    sodium: "",
    bloodSugarLevel: "",
    respiratoryRate: "",
    potassium: "",
    oxygenSaturation: "",
    temperature: "",
    bloodPressure: "",
    heartRate: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevValue) => {
      return {
        ...prevValue,
        [name]:
          type === "checkbox"
            ? checked
            : name === "heartRate"
            ? Number(value)
            : value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    let response;

    // const { error } = BedNumberGroupSchema.validate({
    //   ...formData,
    //   bedSubCategory: formData?.bedSubCategory?._id,
    // });

    // if (error) {
    //   error.details.forEach((err) => toast.error(err.message));
    //   return;
    // }

    setIsLoading(true);
    if (selectedRow?._id) {
      response = await addNursingAssessmentApi({
        ...formData,
        patientId: selectedRow?.occupancyDetails?.patientId,
        visit: selectedRow?.occupancyDetails?.visitId,
      });
    } else {
      response = await addNursingAssessmentApi(formData);
    }
    setIsLoading(false);

    if (response?.code === 200) {
      toast.success(
        response?.message ||
          `Nursing Assessment ${
            selectedRow?._id ? "updated" : "added"
          } successfully`
      );
      setFormData(initialState);
      onClose();
      // refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };
  useEffect(() => {
    if (selectedRow?._id) {
      setFormData({
        ...initialState,
        patientId: selectedRow?.patientId || "",
        visit: selectedRow?.visit || "",
        sodium: selectedRow?.sodium || "",
        bloodSugarLevel: selectedRow?.bloodSugarLevel || "",
        respiratoryRate: selectedRow?.respiratoryRate || "",
        potassium: selectedRow?.potassium || "",
        oxygenSaturation: selectedRow?.oxygenSaturation || "",
        temperature: selectedRow?.temperature || "",
        bloodPressure: selectedRow?.bloodPressure || "",
        heartRate: selectedRow?.heartRate ?? 0,
      });
    } else {
      setFormData(initialState);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "20px",
          }}
        >
          <Typography variant="h6" sx={{ color: "#5D6A82" }}>
            Nursing Assessment
          </Typography>
          <Close
            onClick={onClose}
            sx={{ cursor: "pointer", color: "#5D6A82" }}
          />
        </Box>

        <Box component="form" onSubmit={handleSubmit}>
          <Grid
            container
            spacing={3}
            sx={{
              mb: "20px",
            }}
          >
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Sodium"
                name="sodium"
                value={formData?.sodium || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Potassium"
                name="potassium"
                value={formData?.potassium || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Blood Pressure (BP)"
                name="bloodPressure"
                value={formData?.bloodPressure || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Blood Sugar Level"
                name="bloodSugarLevel"
                value={formData?.bloodSugarLevel || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Oxygen Saturation (02 Levels)"
                name="oxygenSaturation"
                value={formData?.oxygenSaturation || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Heart Rate"
                name="heartRate"
                value={formData?.heartRate || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Respiratory Rate"
                name="respiratoryRate"
                value={formData?.respiratoryRate || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Temperature"
                name="temperature"
                value={formData?.temperature || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
          </Grid>

          {/* submit button */}
          <Box sx={{ my: "20px", textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{ width: "150px", textTransform: "none" }}
              type="submit"
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NursingAssessmentModal;
